<template>
  <div>
    <!-- CSHSE0258985 -->
    <!-- 订单列表 -->
    <div class="table-list bg-white mb15 border-radius-4">
      <div class="ptb18 plr20 border-b">
        <p class="ft12">
          <span class="cmain mr30 ft14 fw700"><span class="iconfont iconicon-zhongjianbaise ft16 cmain mr8 fw400"></span>进仓编号：<span class="">{{ consignOrderNo || '--' }}</span></span>
        </p>
      </div>
      <div class="table-cont">
        <a-row class="flex table-header plr10 flex-justify">
          <!-- <div class="table-header-item c888 0" style="width:3%;">
            <a-checkbox style="padding:0;" :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">
            </a-checkbox>
          </div> -->
          <div class="table-header-item c888 1" style="width:8%;">入库日期</div>
          <div class="table-header-item c888 2" style="width:8%;">数量</div>
          <div class="table-header-item c888 3" style="width:8%;">包装单位</div>
          <div class="table-header-item c888 4" style="width:8%;">长(CM)</div>
          <div class="table-header-item c888 5" style="width:8%;">宽(CM)</div>
          <div class="table-header-item c888 6" style="width:8%;">高(CM)</div>
          <div class="table-header-item c888 7" style="width:8%;">体积</div>
          <div class="table-header-item c888 8" style="width:16%;">仓库名称</div>
          <div class="table-header-item c888 9" style="width:16%;">备注</div>
          <div class="table-header-item c888 10" style="width:7%;">文件
          </div>
        </a-row>
        <a-row v-for="(order,i) in dataList" :key="i" class="flex table-con tc ptb10 plr10 flex-acenter flex-justify">
          <!-- <div class="table-con-item c333 0" style="width:3%;">
            <a-checkbox style="padding:0;" :checked="order.checked" @change="onCheckItemChange">
            </a-checkbox>
          </div> -->
          <div class="table-con-item c333 1" style="width:8%;">{{ order.ReceiveDate || '  ' }}</div>
          <div class="table-con-item c333 2" style="width:8%;">{{ order.Qty || '  ' }}</div>
          <div class="table-con-item c333 3" style="width:8%;">{{ order.PackUnit || '  ' }}</div>
          <div class="table-con-item c333 4" style="width:8%;">{{ order.Length || '  ' }}</div>
          <div class="table-con-item c333 5" style="width:8%;">{{ order.Width || '  ' }}</div>
          <div class="table-con-item c333 6" style="width:8%;">{{ order.Height || '  ' }}</div>
          <div class="table-con-item c333 7" style="width:8%;">{{ (+order.Volume||0).toFixed(3) || '  ' }}</div>
          <div class="table-con-item c333 8" style="width:16%;">{{ order.WHName || '  ' }}</div>
          <div class="table-con-item c333 9" style="width:16%;">{{ order.Remark || '  ' }}</div>
          <div class="table-con-item c333 10" style="width:7%;">
            <a-popover v-if="order.file&&order.file.length>0" placement="left" trigger="click">
              <template slot="content">
                <p v-for="(file,iii) in order.file" :key="iii" class="mb5"><a href="javascript:;" @click="downloadItem(file)">{{ file.filename }}</a></p>
              </template>
              <template slot="title">
                <span>文件列表</span>
              </template>
              <a href="javascript:;">文件列表</a>
            </a-popover>
          </div>
        </a-row>
        <a-row class="flex table-con tc ptb10 plr10 flex-acenter flex-justify border-t">
          <div class="table-con-item c333 fw700" style="width:8%;">合计</div>
          <div class="table-header-item c666 2" style="width:8%;">{{ (orderTotal.totalQty || 0).toFixed(2) }}</div>
          <div class="table-header-item c888 3" style="width:8%;"></div>
          <div class="table-header-item c888 4" style="width:8%;"></div>
          <div class="table-header-item c888 5" style="width:8%;"></div>
          <div class="table-header-item c888 6" style="width:8%;"></div>
          <div class="table-header-item c666 7" style="width:8%;">{{ (orderTotal.totalVolume || 0).toFixed(2) }}</div>
          <div class="table-header-item c888 8" style="width:16%;"></div>
          <div class="table-header-item c888 9" style="width:16%;"></div>
          <div class="table-header-item c888 10" style="width:7%;"></div>
        </a-row>
      </div>
    </div>
  </div>
</template>

<script>
import { dateToString } from '@/utils/date-formatter'
import { Ellipsis } from '@/components'
// import { down } from '@/utils/zipDownload'
export default {
  name: 'TableList',
  components: { Ellipsis },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    activeMenu: {
      type: String,
      default: '1'
    },
    consignOrderNo: {
      type: String,
      default: ''
    },
    orderTotal: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      List: [],
      checkedList: [],
      plainOptions: [],
      indeterminate: false,
      checkAll: false
    }
  },
  mounted () {
    this.List.length = this.dataList.length
  },
  methods: {
    dateToString,
    collapseChange (index) {
      this.List[index] = !this.List[index]
      this.List = JSON.parse(JSON.stringify(this.List))
    },
    onChange (checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.dataList.length
      this.checkAll = checkedList.length === this.dataList.length
    },
    onCheckAllChange (e) {
      Object.assign(this, {
        checkedList: e.target.checked ? this.dataList : [],
        indeterminate: false,
        checkAll: e.target.checked
      })
    },
    onCheckItemChange (e) {
      console.log(e)
    },
    isIE () {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true
      } else {
        return false
      }
    },
    downloadItem (item) {
      // const url = 'https://oss-svc.oss-cn-shanghai.aliyuncs.com/etiger56/template/%E5%9B%BD%E5%86%85%E7%BD%91%E7%BB%9C%E8%B4%A7%E8%BF%90%E5%A7%94%E6%89%98%E8%BF%90%E8%BE%93%E5%8D%8F%E8%AE%AE-%E8%B4%A7%E4%B8%BB.pdf'
      const url = item.filepath
      window.open(url, '_blank')
      // if (this.isIE()) { // IE
      // } else {
      //   const a = document.createElement('a') // 创建a标签
      //   const e = document.createEvent('MouseEvents') // 创建鼠标事件对象
      //   e.initEvent('click', false, false) // 初始化事件对象
      //   a.href = url // 设置下载地址
      //   a.download = 'xxxx表' // 设置下载文件名
      //   a.dispatchEvent(e)
      // }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../../../styles/var.less';
.table-cont {
  .table-header {
    background-color: @light-blue-bg-table;
    height: 40px;
    line-height: 40px;
    .table-header-item {
      text-align: center;
      padding: 0 5px;
    }
  }
  .table-con {
    &:nth-child(odd) {
      background-color: @bg-color-gray;
    }
    .table-con-item {
      padding: 0 5px;
      text-align: center;
      word-wrap:break-word;
      line-height: 1.2;
      min-height: 20px;
    }
  }
}
.nowarp {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
